import React, { useCallback } from 'react';

import { Box, ButtonBase, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { PreviewMarksPropType } from '../../FormChangeHistory.propTypes';
import { partTextStyles } from '../../FormChangeHistory.styles';
import { FormChangeHistoryTestIds } from '../../FormChangeHistory.testIds';
import PreviewMarkBadge from '../PreviewMarkBadge';

import { getMarkNameStyles, getMarkRowStyles, markListStyles } from './PreviewMarkList.styles';

/**
 * Numbered changes: what changed, and the part it changed. Given `onToggleMark`, each row is a
 * toggle that highlights its change on the pages.
 */
const PreviewMarkList = ({ marks, highlightedMarkId = null, onToggleMark = null }) => {
  const isSelectable = !!onToggleMark;

  const onRowClick = useCallback(
    event => onToggleMark(event.currentTarget.dataset.markId),
    [onToggleMark],
  );

  return (
    <Box sx={markListStyles}>
      {marks.map(mark => {
        const isHighlighted = mark.id === highlightedMarkId;

        return (
          <Box
            aria-pressed={isSelectable ? isHighlighted : null}
            component={isSelectable ? ButtonBase : 'div'}
            data-mark-id={mark.id}
            data-number={mark.number}
            data-testid={FormChangeHistoryTestIds.PREVIEW_MARK_ROW}
            key={mark.id}
            sx={getMarkRowStyles({ isSelectable, isHighlighted })}
            onClick={isSelectable ? onRowClick : null}
          >
            <PreviewMarkBadge number={mark.number} />
            <Box sx={partTextStyles}>
              <Typography variant="medium14">{mark.title}</Typography>
              <Typography color="text.secondary" sx={getMarkNameStyles(mark)} variant="regular12">
                {mark.name}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

PreviewMarkList.propTypes = {
  marks: PreviewMarksPropType.isRequired,
  highlightedMarkId: PropTypes.string,
  onToggleMark: PropTypes.func,
};

export default PreviewMarkList;
